// extracted by mini-css-extract-plugin
export var deliveryRow = "_s6-a";
export var fixedHeight = "_s6-4";
export var freightLogo = "_s6-9";
export var fullWidth = "_s6-3";
export var priceColumn = "_s6-5";
export var radioSelected = "_s6-7";
export var radioUnselected = "_s6-6";
export var selectedOption = "_s6-2";
export var selectedOptionContainer = "_s6-1";
export var selection = "_s6-0";
export var tallSkeletonText = "_s6-8";